import React from "react";
import Column from "./Column";

export default function Board({ columns, setColumns }) {
    return (
        <div className="board" style={{ display: "flex", gap: "20px", padding: "20px" }}>
            {columns.map((col) => (
                <Column
                    key={col.id}
                    column={col}
                    columns={columns}
                    setColumns={setColumns}
                />
            ))}
        </div>
    );
}
